import React from 'react'

export default function Carousel({type, img1, img2, img3, carouselId}) {


    return (
        <React.Fragment>
          <div id={carouselId} className="carousel slide">
            <div className="carousel-inner">

            {
              type === "web-app" ?
              (
              <React.Fragment>
                <div className="carousel-item active">
                  <img src={img1} className="d-block w-100" alt="img-01"/>
                </div>
                {/* <div className="carousel-item">
                <img src={img2} className="d-block w-100" alt="img-02"/>
                </div> */}
              </React.Fragment>
              ) 
              :
              (
                <React.Fragment>
                  <div className="carousel-item active">
                    <img src={img1} className="d-block w-100" alt="img-01" />
                  </div>
                  <div className="carousel-item">
                  <img src={img2} className="d-block w-100" alt="img-02" />
                  </div>
                  <div className="carousel-item">
                  <img src={img3} className="d-block w-100" alt="img-03" />
                  </div>
                </React.Fragment>
              )

            }


            </div>

            <button className="carousel-control-prev" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target={`#${carouselId}`} data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </React.Fragment>
    )
}